
import _permissao from "@universidade-franciscana/componente-front/src/enums/permissao.js"

export default [
    {
        path: "/ambiente/:turmaId/",
        name: "lista-datas",
        component: () => import("@/views/plano/Ambiente.vue"),
        meta: {
            title: "Lista de Datas",
            caminho: "lista-datas", // parâmetro utilizado nas permissões de acesso
            tipoPermissao: _permissao.LISTAR, // parâmetro utilizado nas permissões de acesso
            breadcrumb: [
                {
                    text: "Lista de disciplinas",
                    disabled: false,
                    to: "/",
                },
                { text: "Lista de Datas", disabled: true },
            ],
        },
    },
    {
        path: "/gerenciar/:cadernoId/:turmaId/:atividadeId?",
        name: "gerenciar-data",
        component: () => import("@/views/plano/Gerenciar.vue"),
        meta: {
            title: "Gerenciar data",
            caminho: "gerenciar-data", // parâmetro utilizado nas permissões de acesso
            tipoPermissao: _permissao.GERENCIAR, // parâmetro utilizado nas permissões de acesso
            breadcrumb(route) {
                return [
                    {
                        text: "Lista de disciplinas",
                        disabled: false,
                        to: "/",
                    },
                    {
                        text: "Lista de Datas",
                        disabled: false,
                        to: `/ambiente/${route.params.turmaId}`,
                    },
                    { text: "Gerenciar Data", disabled: true },
                ]
            },
        },
    },
    {
        path: "/comparar-data/:turmaParaId/:turmaDeId",
        name: "comparar-data",
        component: () => import("@/views/plano/CompararData.vue"),
        meta: {
            title: "Comparar data",
            caminho: "comparar-data", // parâmetro utilizado nas permissões de acesso
            tipoPermissao: _permissao.GERENCIAR, // parâmetro utilizado nas permissões de acesso
            breadcrumb(route) {
                return [
                    {
                        text: "Lista de disciplinas",
                        disabled: false,
                        to: "/",
                    },
                    {
                        text: "Lista de Datas",
                        disabled: false,
                        to: `/ambiente/${route.params.turmaParaId}`,
                    },
                    { text: "Comparar Data", disabled: true },
                ]
            },
        },
    },
]
